import { toast } from "sonner";
import React, { useState } from "react";
import { isAfter, isBefore } from "date-fns";
import { useNavigate } from "react-router-dom";
import { RiShareBoxFill } from "react-icons/ri";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import { FaArrowRotateLeft } from "react-icons/fa6";
import LoadingSpinner from "../../Components/spinner";
import { handleErrors, stringToColor } from "../../services/dataManager";
import { Button, Table, Modal, Form } from "react-bootstrap";
import {
  applyFilters,
  changeSectionStatus,
  deleteHomePageSection,
  restoreSection,
} from "../../services/axios/apiManager";
import SectionTypesModal from "./sectionTypesModal";

const HomePageList = ({ sections, setSections, getData }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("");
  const [sectionType, setSectionType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);

  // // // Check wether section is expired or ongoing
  const getEventStatus = (content, now = new Date()) =>
    isBefore(new Date(content?.end_date), now) ? (
      <span className="text-danger">Expired</span>
    ) : isAfter(new Date(content?.start_date), now) ? (
      <span className="text-warning">In_future</span>
    ) : (
      <span className="text-success">In_progress</span>
    );

  // // // Setting classes for section type drop down
  const getClass = () =>
    sectionType === "permanent"
      ? "text-info"
      : sectionType === "progress"
        ? "text-success"
        : sectionType === "future"
          ? "text-warning"
          : sectionType === "expired"
            ? "text-danger"
            : "text-light";

  // // // Delete section
  const handleDelete = (item) => {
    setModalOptions({
      header: "Delete Section",
      body: `Are you sure you want to delete section "${item.heading}"?`,
      okay: "Delete",
      method: deleteSection,
      data: { id: item.id },
    });
    setShowOptionsModal(true);
  };

  const deleteSection = async (data) => {
    setLoading(true);
    const res = await deleteHomePageSection(data.id);
    if (res?.data?.success) {
      await getData();
      toast.info(
        res?.data?.message || "Section has been deleted successfuly.",
        { duration: 3000 },
      );
      handleCloseOptionsModal();
    } else {
      handleErrors(res, null, "Home Page:");
    }
    setLoading(false);
  };

  // // // Change section Status
  const handleStatus = (item) => {
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change status of "${item.heading}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: item.id, status: item.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    setLoading(true);
    const res = await changeSectionStatus(data);
    if (res?.data?.success) {
      await getData();
      toast.info(
        res?.data?.message || "Section status has been updated successfuly.",
        { duration: 3000 },
      );
      handleCloseOptionsModal();
    } else {
      handleErrors(res, null, "Home Page:");
    }
    setLoading(false);
  };

  // // // Restore deleted section
  const handleRestoreSection = (item) => {
    setModalOptions({
      header: "Restore Section",
      body: `Are you sure you want to restore "${item.heading}"?`,
      okay: "Restore",
      method: restorePageSection,
      data: { id: item.id },
    });
    setShowOptionsModal(true);
  };

  const restorePageSection = async (data) => {
    setLoading(true);
    const res = await restoreSection(data.id);
    if (res?.data?.success) {
      if (query || status || sectionType) {
        await handleApplyFilters(query, status, sectionType);
      } else {
        await getData();
      }
      toast.info(
        res?.data?.message || "Section status has been updated successfuly.",
        { duration: 3000 },
      );
      handleCloseOptionsModal();
    } else {
      handleErrors(res, navigate, "Restore Page Section: ");
    }
    setLoading(false);
  };

  const handleCloseOptionsModal = () => {
    setShowOptionsModal(false);
    setModalOptions({});
  };

  // // // Applying all filters
  const handleApplyFilters = async (secQuery, secStatus, type) => {
    // // // keep sequence exactly as follows query, status and then section type
    const res = await applyFilters(secQuery, secStatus, type);
    if (res?.data?.success) {
      setSections(res?.data?.data);
    } else {
      handleErrors(res, navigate, "Home Page: ");
    }
  };

  // // // Reset filters and fetch data again
  const resetFilters = async () => {
    setLoading(true);
    setSectionType("");
    setQuery("");
    setStatus("");
    await getData();
    setLoading(false);
  };
  return (
    <div className="bg-dark p-4 rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="row col-md-12">
          <div className="col-xs-12 col-md-3">
            <Form.Control
              type="text"
              placeholder="serach..."
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                handleApplyFilters(e.target.value, status, sectionType);
              }}
            />
          </div>
          <div className="col-xs-12 col-md-2">
            <Form.Select
              name="section-type"
              value={sectionType}
              className={getClass()}
              onChange={(e) => {
                setSectionType(e.target.value);
                handleApplyFilters(query, status, e.target.value);
              }}
            >
              <option className="text-light" value="">
                All Sections
              </option>
              <option className="text-info" value="permanent">
                Permanent
              </option>
              <option className="text-success" value="progress">
                In-Progress
              </option>
              <option className="text-warning" value="future">
                Future
              </option>
              <option className="text-danger" value="expired">
                Expired
              </option>
            </Form.Select>
          </div>
          <div className="col-xs-12 col-md-2">
            <Form.Select
              className={status === "deleted" ? "text-danger" : "text-light"}
              name="status"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                handleApplyFilters(query, e.target.value, sectionType);
              }}
            >
              <option className="text-light" value="3">
                Active & In-Active
              </option>
              <option className="text-light" value="1">
                Active
              </option>
              <option className="text-light" value="0">
                In-Active
              </option>
              <option className="text-danger" value="2">
                Deleted
              </option>
            </Form.Select>
          </div>
          <div className="col-xs-12 col-md-1">
            <div className="row">
              <Button
                title="Reset Filters And Rrfresh Records"
                className="btn btn-success"
                disabled={loading}
                onClick={() => {
                  resetFilters();
                }}
              >
                {loading ? (
                  <LoadingSpinner size={"sm"} variant={"light"} />
                ) : (
                  "Reset"
                )}
              </Button>
            </div>
          </div>
          <div className="col-xs-12 col-md-4">
            <div className="d-flex justify-content-end gap-2">
              <Button
                title="Review all sections"
                className="btn btn-success"
                onClick={() => {
                  navigate("/review-sections");
                }}
              >
                Review Page
              </Button>
              <Button
                title="Add New Section"
                className="btn btn-success"
                onClick={() => {
                  setShowModal(true);
                  // navigate("/add-section");
                }}
              >
                Add Section
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="table-responsive mt-4">
        <Table striped hover variant="dark" className="mt-4">
          <thead>
            <tr>
              <th>Heading</th>
              <th>Section Type</th>
              <th>Games</th>
              <th>Period</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sections?.length > 0 &&
              sections.map((content, index) => (
                <tr key={index}>
                  <td>{content?.heading}</td>
                  <td style={{ color: stringToColor(content?.section_type) }}>
                    {content?.section_type}
                  </td>
                  {content?.games_included ? (
                    <td>{`${content?.games_list?.length} games`}</td>
                  ) : (
                    // <td>
                    //   <button
                    //     className="btn btn-link d-flex align-items-center text-primary"
                    //     style={{ textDecoration: "none" }}
                    //     onClick={() => {}}
                    //   >
                    //     {`${content?.games?.length} games`}
                    //     <RiShareBoxFill className="mx-1" />
                    //   </button>
                    // </td>
                    <td>Not Included</td>
                  )}
                  {content?.is_timed ? (
                    <td>{getEventStatus(content)}</td>
                  ) : (
                    <td className="text-info">Permanent</td>
                  )}
                  <td>
                    <button
                      title="change section status"
                      className={`btn btn-link p-0 m-0 border-0 ${
                        content?.status ? "text-success" : "text-danger"
                      }`}
                      onClick={() => {
                        handleStatus(content);
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      {content?.status === 1 ? "Active" : "Inactive"}
                    </button>
                  </td>
                  <td className="w-40">
                    <Button
                      title="Review section"
                      variant="outline-success"
                      size="sm"
                      onClick={() => {
                        navigate(`/review-sections/${content.section_id}`);
                      }}
                    >
                      <FaEye />
                    </Button>
                    <Button
                      title="edit section"
                      variant="outline-primary"
                      className="ml-1 mr-1"
                      size="sm"
                      onClick={() => {
                        navigate(`/add-edit-section?id=${content.section_id}`);
                      }}
                    >
                      <FaEdit />
                    </Button>
                    {content?.status === 0 && content?.deletedAt === null && (
                      <Button
                        title="delete section"
                        variant="outline-danger"
                        size="sm"
                        onClick={() => {
                          handleDelete(content);
                        }}
                      >
                        <FaTrashAlt />
                      </Button>
                    )}
                    {content?.deletedAt && (
                      <Button
                        title="Restore Section"
                        variant="outline-info"
                        size="sm"
                        onClick={() => {
                          handleRestoreSection(content);
                        }}
                      >
                        <FaArrowRotateLeft />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          {loading && <LoadingSpinner size={"lg"} variant={"light"} />}
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
      <SectionTypesModal
        showModal={showModal}
        setShowModal={setShowModal}
        navigate={navigate}
      />
    </div>
  );
};

export default HomePageList;
